export const getAngleNumber = (deg) => {
    //градусы из настроек 1; 2; 5; 10; 15; 30; 45; 60; 90; 180
    // 180 = Math.PI

    return Math.PI / (180 / parseFloat(deg));
}

export const getAngleDegree = (number) => {
    return 180 / (Math.PI / parseFloat(number));
}
